import gsap from 'gsap'
import Base from '../../../src/js/classes/Base'

const CUSTOM_LOGIN_STATES = {
	LOGIN: 'login',
	FORGOT_PASSWORD: 'forgot-password',
	RESET_PASSWORD: 'reset-password',
}

export default class CustomLogin extends Base {
	constructor(el) {
		super({
			element: el,
			elements: {
				loginForm: '.s-CustomLogin__login form',
				resetForm: '.s-CustomLogin__reset-password form',
				loginErrors: '.s-CustomLogin__login__errors',
				resetErrors: '.s-CustomLogin__reset-password__errors',
				forgotPasswordForm: '.s-CustomLogin__forgot-password form',
				forgotPasswordErrors: '.s-CustomLogin__forgot-password__errors',
				forgotPasswordButton: '.s-CustomLogin__login__buttons [data-action="forgot-password"]',
				loginButtons: '[data-action="login"]',
			},
			options: {},
			classes: {
				loginOpen: 'login-open',
				isLoading: 'is-loading',
				isError: 'is-error',
				stateLogin: 'state-login',
				stateForgotPassword: 'state-forgot-password',
				stateResetPassword: 'state-reset-password',
			},
			state: {
				screen: CUSTOM_LOGIN_STATES.LOGIN,
			},
		})
	}

	/**
	 * Create.
	 */

	init() {
		this.elements.loginButtons = gsap.utils.toArray(this.elements.loginButtons)
		this.checkIfResetting()
		this.addEvents()
	}

	addEvents() {
		this.elements.loginForm.addEventListener('submit', this.onSubmitLoginForm.bind(this))
		this.elements.resetForm.addEventListener('submit', this.onSubmitPasswordResetForm.bind(this))
		this.elements.forgotPasswordForm.addEventListener('submit', this.onSubmitForgotPasswordForm.bind(this))
		this.elements.forgotPasswordButton.addEventListener('click', this.onClickForgotPassword.bind(this))
		this.elements.loginButtons.forEach((loginButton) => {
			loginButton.addEventListener('click', this.onClickLogin.bind(this))
		})
	}

	/**
	 * Event Listeners.
	 */

	onSubmitLoginForm(e) {
		e.preventDefault()
		const formData = new FormData(this.elements.loginForm)
		const formObject = Object.fromEntries(formData.entries())
		let request = {
			...formObject,
			action: 'login',
			nonce: window.my_ajax.nonce,
			redirect_url: window.location.href,
		}
		const params = new URLSearchParams(request)

		this.elements.loginForm.classList.add(this.classes.isLoading)

		fetch(window.my_ajax.ajaxurl, {
			method: 'POST',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
			body: params.toString(),
		})
			.then((response) => response.json())
			.then((data) => {
				if (data.success) {
					this.elements.loginErrors.innerHTML = ''
					this.elements.loginForm.classList.remove(this.classes.isError)
					window.location.assign(data.data.redirect)
				} else {
					const message = data.data.message
					this.elements.loginErrors.innerHTML = message
					this.elements.loginForm.classList.add(this.classes.isError)
				}
				this.elements.loginForm.classList.remove(this.classes.isLoading)
			})
			.catch((error) => {
				console.error('Error:', error)
				this.elements.loginErrors.innerHTML = 'Sorry, there was an issue logging in. Please try again.'
				this.elements.loginForm.classList.add(this.classes.isError)
				this.elements.loginForm.classList.remove(this.classes.isLoading)
			})
	}

	onSubmitForgotPasswordForm(e) {
		e.preventDefault()
		const formData = new FormData(this.elements.forgotPasswordForm)
		const formObject = Object.fromEntries(formData.entries())
		let request = {
			...formObject,
			action: 'forgot_password',
			nonce: window.my_ajax.nonce,
			redirect_url: window.location.href,
		}
		const params = new URLSearchParams(request)

		this.elements.forgotPasswordForm.classList.add(this.classes.isLoading)

		fetch(window.my_ajax.ajaxurl, {
			method: 'POST',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
			body: params.toString(),
		})
			.then((response) => response.json())
			.then((data) => {
				if (data.success) {
					this.elements.forgotPasswordErrors.innerHTML = ''
					this.elements.forgotPasswordForm.classList.remove(this.classes.isError)
					this.resetParams()
				} else {
					const message = data.data.message
					this.elements.forgotPasswordErrors.innerHTML = message
					this.elements.forgotPasswordForm.classList.add(this.classes.isError)
				}
				this.elements.forgotPasswordForm.classList.remove(this.classes.isLoading)
			})
			.catch((error) => {
				console.error('Error:', error)
				this.elements.forgotPasswordErrors.innerHTML = 'Sorry, there was an issue logging in. Please try again.'
				this.elements.forgotPasswordForm.classList.add(this.classes.isError)
				this.elements.forgotPasswordForm.classList.remove(this.classes.isLoading)
			})
	}

	onSubmitPasswordResetForm(e) {
		e.preventDefault()
		const formData = new FormData(this.elements.resetForm)
		const formObject = Object.fromEntries(formData.entries())
		let request = {
			...formObject,
			action: 'reset_password',
			nonce: window.my_ajax.nonce,
			redirect_url: window.location.href,
		}
		const params = new URLSearchParams(request)

		this.elements.resetForm.classList.add(this.classes.isLoading)

		fetch(window.my_ajax.ajaxurl, {
			method: 'POST',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
			body: params.toString(),
		})
			.then((response) => response.json())
			.then((data) => {
				if (data.success) {
					this.elements.resetErrors.innerHTML = ''
					this.elements.resetForm.classList.add(this.classes.isError)
					this.elements.resetErrors.innerHTML = data.data.message
					this.elements.resetForm.reset()
					this.resetParams()
				} else {
					const message = data.data.message
					this.elements.resetErrors.innerHTML = message
					this.elements.resetForm.classList.add(this.classes.isError)
				}
				this.elements.resetForm.classList.remove(this.classes.isLoading)
			})
			.catch((error) => {
				console.error('Error:', error)
				this.elements.resetErrors.innerHTML = 'Sorry, there was an issue logging in. Please try again.'
				this.elements.resetForm.classList.add(this.classes.isError)
				this.elements.resetForm.classList.remove(this.classes.isLoading)
			})
	}

	onClickForgotPassword() {
		this.setState({ screen: CUSTOM_LOGIN_STATES.FORGOT_PASSWORD })
	}
	onClickLogin() {
		this.setState({ screen: CUSTOM_LOGIN_STATES.LOGIN })
	}

	onStateChange(newState) {
		if ('screen' in newState) {
			if (newState.screen === CUSTOM_LOGIN_STATES.FORGOT_PASSWORD) {
				this.showForgotPassword()
			} else if (newState.screen === CUSTOM_LOGIN_STATES.LOGIN) {
				this.showLogin()
			} else if (newState.screen === CUSTOM_LOGIN_STATES.RESET_PASSWORD) {
				this.showResetPassword()
			}
		}
	}

	/**
	 * Methods.
	 */
	resetParams() {
		const url = new URL(window.location.href)
		const params = url.searchParams

		params.delete('action')
		params.delete('login')
		params.delete('key')
		params.delete('logout')
		params.delete('successful_login')
		const newUrl = url.origin + url.pathname + (params.toString() ? '?' + params.toString() : '')
		window.history.replaceState({}, document.title, newUrl)
	}

	open() {
		document.body.classList.add(this.classes.loginOpen)
	}

	close() {
		document.body.classList.remove(this.classes.loginOpen)
	}

	checkIfResetting() {
		const params = new URLSearchParams(window.location.search)

		if (params.has('key') && params.has('login') && params.get('action') === 'rp') {
			this.setState({ screen: CUSTOM_LOGIN_STATES.RESET_PASSWORD })
			this.open()
		}
	}

	showForgotPassword() {
		this.element.classList.add(this.classes.stateForgotPassword)
		this.element.classList.remove(this.classes.stateLogin)
		this.element.classList.remove(this.classes.stateResetPassword)
	}

	showLogin() {
		this.element.classList.remove(this.classes.stateForgotPassword)
		this.element.classList.add(this.classes.stateLogin)
		this.element.classList.remove(this.classes.stateResetPassword)
	}

	showResetPassword() {
		this.element.classList.remove(this.classes.stateForgotPassword)
		this.element.classList.remove(this.classes.stateLogin)
		this.element.classList.add(this.classes.stateResetPassword)
	}

	/**
	 * Destroy.
	 */

	unmount() {
		this.removeEvents()
	}

	removeEvents() {
		this.elements.loginForm.removeEventListener('submit', this.onSubmitLoginForm.bind(this))
		this.elements.resetForm.removeEventListener('submit', this.onSubmitPasswordResetForm.bind(this))
		this.elements.forgotPasswordForm.removeEventListener('submit', this.onSubmitForgotPasswordForm.bind(this))
		this.elements.forgotPasswordButton.removeEventListener('click', this.onClickForgotPassword.bind(this))
		this.elements.loginButtons.forEach((loginButton) => {
			loginButton.removeEventListener('click', this.onClickLogin.bind(this))
		})
	}
}
